import { Link } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import useNotify from "../utils/useNotify";
import { Box, Paper } from "@mui/material";
import {
  Close,
  Download,
  FilterAlt,
  ReplayCircleFilled,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import {
  Typography,
  Table,
  Tabs,
  Button,
  Drawer,
  Form,
  Select,
  Divider,
  DatePicker,
  Tooltip,
  Space,
  Radio,
  Input,
} from "antd";
import { showloader } from "../store/gloabalState";
import { DateConvert } from "../utils/dateConverter";
import {
  getFilteredTransactionAll,
  getInwardTransactions,
  getAllOrgName,
  getAllOpsMember,
  getFilteredTransactionAllDownload,
  getAllTransactionDownload,
} from "../services/httpCalls";
import FileDownload from "js-file-download";

const InwardTransactions = (props) => {
  const FILTER_STORAGE_KEY = "inwardKeepfilters";
  const [total, setTotal] = useState();
  const [totalBanks, setTotalBanks] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [transactionId, setTransactionId] = useState();
  const [currentPageBank, setCurrentPageBank] = useState(0);
  const [inwardTransactions, setInwardTransactions] = useState([]);
  const [inwardBankTransactions, setInwardBankTransactions] = useState([]);
  const [orgName, setOrgName] = useState();
  const [opsMembers, setOpsMember] = useState();
  const [filtervalues, setFilterValues] = useState({});
  const [filterModeOn, setFilterModeOn] = useState(false);
  const [dateRangeBy, setDateRangeBy] = useState("isDateRangeOnCompletionTime");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [alltxnForm] = Form.useForm();
  const { RangePicker } = DatePicker;

  const setShowLoader = useSetRecoilState(showloader);
  const notify = useNotify();

  const showDrawer = () => setOpenDrawer(true);
  const onCloseDrawer = () => setOpenDrawer(false);

  const isObjectEmpty = (objectName) => {
    return (
      Object.keys(objectName).length === 0 && objectName.constructor === Object
    );
  };

  const getReceivableTransactions = (currentPage) => {
    setShowLoader(true);

    getInwardTransactions(currentPage)
      .then((res) => {
        setInwardTransactions(res.receivablePayoutResponseList);
        setTotal(res.total);
      })
      .catch(() => {
        notify.error("Not able to fetch all transaction");
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const getBankTransactions = (currentPage) => {
    setShowLoader(true);
    getTransactionsWithFilters(filtervalues, currentPage);
  };

  const getAllOrgList = async () => {
    await getAllOrgName()
      .then((res) => {
        let finalCustName = res?.map((cust) => {
          return {
            label: cust?.name ? cust?.name : "--",
            value: cust?.id,
          };
        });
        if (finalCustName?.length) {
          setOrgName(finalCustName);
        } else {
          setOrgName([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getOpsMember = () => {
    getAllOpsMember().then((res) => {
      let opsMember = res;
      let finalOps;
      if (opsMember && Object.keys(opsMember).length) {
        finalOps = Object.keys(opsMember).map((ops, i) => {
          return {
            label: ops,
            value: [Object.values(opsMember)[i]],
          };
        });
        if (finalOps?.length) {
          let formattedOps = finalOps.map((ops) => {
            return {
              label: ops?.label,
              value: ops?.value.join(""),
            };
          });
          setOpsMember(formattedOps);
        }
      }
    });
  };

  function formatDate(date) {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  const getTransactionsWithFilters = (filtersObj, currentPage) => {
    if (filtersObj !== undefined) {
      let organisationId = "";
      let nickname = "";
      let fromDate = "";
      let toDate = "";
      let assignedOpsMemberId = "";
      let stage = "";
      let dateRangeByVal_ = "";
      if (isObjectEmpty(filtersObj) === false) {
        if (filtersObj.CustomerListSelection?.length) {
          organisationId += filtersObj.CustomerListSelection;
        }
        if (filtersObj.nickname) {
          nickname = filtersObj.nickname.trim();
        }
        if (filtersObj.toFrom?.length) {
          if (filtersObj?.toFrom[0]) {
            const originalDate = new Date(filtersObj.toFrom[0]);
            const formattedDate = formatDate(originalDate);
            fromDate = filtersObj?.toFrom[0]
              ? Number(new Date(`${formattedDate} 00:00`))
              : "";
          }
          if (filtersObj?.toFrom[1]) {
            const originalDate = new Date(filtersObj.toFrom[1]);
            const formattedDate = formatDate(originalDate);
            toDate = filtersObj?.toFrom[1]
              ? Number(new Date(`${formattedDate} 23:59:59`))
              : "";
          }
          if (dateRangeBy) {
            dateRangeByVal_ = dateRangeBy;
          }
        }
        if (filtersObj.assignedOpsMemberId?.length) {
          assignedOpsMemberId += filtersObj.assignedOpsMemberId;
        }
        if (filtersObj.stage?.length) {
          stage += filtersObj.stage;
        }
        let OnlySelected = {
          organisationId: organisationId,
          nickname,
          fromDate: fromDate,
          toDate: toDate,
          assignedOpsMemberId: assignedOpsMemberId,
          status: stage,
        };
        setShowLoader(true);
        let filters = "";
        Object.keys(OnlySelected).map((item) => {
          if (OnlySelected[item] !== "") {
            filters += `${item}=${OnlySelected[item]}&`;
          }
        });
        if (dateRangeByVal_ && filtersObj.toFrom?.length) {
          filters += `${dateRangeByVal_}=true&`;
        }
        if (!filters) {
          filters = `productType=INWARD&`;
        } else {
          filters += `productType=INWARD&`;
        }
        getFilteredTransactionAll(filters, currentPage)
          .then((res) => {
            if (res) {
              setInwardBankTransactions(res.transactionDetailResponseDtoList);
              setTotalBanks(res.totalCount);
            } else {
              notify.error("Cannot fetch transactions!");
            }
          })
          .catch(() => {
            notify.error("Cannot fetch transactions!");
          })
          .finally(() => setShowLoader(false));
      }
    }
  };

  useEffect(() => {
    getAllOrgList();
    getOpsMember();
  }, []);

  const retainFilters = async (formSett) => {
    await setFilterValues(formSett);
    if (formSett.stage?.length) {
      alltxnForm.setFieldValue("stage", formSett.stage);
    }
    if (formSett.CustomerListSelection?.length) {
      alltxnForm.setFieldValue(
        "CustomerListSelection",
        formSett.CustomerListSelection
      );
    }
    if (formSett.nickname) {
      alltxnForm.setFieldValue("nickname", formSett.nickname);
    }
    if (formSett.assignedOpsMemberId?.length) {
      alltxnForm.setFieldValue(
        "assignedOpsMemberId",
        formSett.assignedOpsMemberId
      );
    }
    await getTransactionsWithFilters(formSett, currentPageBank);
  };

  useEffect(() => {
    getBankTransactions(currentPageBank);
  }, [filtervalues, filterModeOn]);

  useEffect(() => {
    let formSett = [];
    if (
      localStorage.getItem(FILTER_STORAGE_KEY) !== null ||
      localStorage.getItem(FILTER_STORAGE_KEY) !== undefined
    ) {
      let filtersLocalStorage = localStorage.getItem(FILTER_STORAGE_KEY);
      if (filtersLocalStorage) {
        formSett = JSON.parse(filtersLocalStorage);
      }
    }
    retainFilters(formSett);
  }, [currentPageBank, filterModeOn]);

  const handleFiltersDownload = async () => {
    if (Object.keys(filtervalues).length === 0) {
      let defaultFilters = `fromDate=${Number(
        new Date(Date.now() - 2592000000).setHours(0, 0, 0, 0)
      )}&toDate=${Number(Date.now())}`;

      setShowLoader(true);
      await getAllTransactionDownload(defaultFilters, "INWARD")
        .then((res) => {
          if (res !== "" && res !== undefined) {
            FileDownload(res, "Transaction.xlsx");
            notify.success("Downloaded!");
          } else {
            notify.error("Not able to download file in given filter!");
          }
        })
        .catch(() => {
          notify.error("Error while Downloading!");
        })
        .finally(() => {
          setShowLoader(false);
        });
    } else {
      setShowLoader(true);
      const originalDateFrom = new Date(filtervalues?.toFrom?.[0]);
      const formattedDateFrom = formatDate(originalDateFrom);
      const originalDateTo = new Date(filtervalues?.toFrom?.[1]);
      const formattedDateTo = formatDate(originalDateTo);
      let OnlySelectedFilters = {
        organisationId: filtervalues?.CustomerListSelection
          ? filtervalues?.CustomerListSelection.join(",")
          : "",
        nickname: filtervalues?.nickname ? filtervalues.nickname.trim() : "",
        fromDate: filtervalues?.toFrom?.length
          ? filtervalues?.toFrom[0]
            ? Number(new Date(`${formattedDateFrom} 00:00`))
            : Number(new Date(Date.now() - 2592000000).getTime())
          : Number(new Date(Date.now() - 2592000000).setHours(0, 0, 0, 0)),
        toDate: filtervalues?.toFrom?.length
          ? filtervalues?.toFrom[1]
            ? Number(new Date(`${formattedDateTo} 23:59:59`))
            : Number(Date.now())
          : Number(Date.now()),
        asssignedOpsMemberId: filtervalues?.assignedOpsMemberId
          ? filtervalues?.assignedOpsMemberId.join(",")
          : "",
        status: filtervalues?.stage ? filtervalues?.stage.join(",") : "",
      };
      if (dateRangeBy) {
        OnlySelectedFilters[`${dateRangeBy}`] = true;
      }
      let filters = "";
      Object.keys(OnlySelectedFilters).map((item) => {
        if (OnlySelectedFilters[item] !== "") {
          filters += `${item}=${OnlySelectedFilters[item]}&`;
        }
      });
      await getFilteredTransactionAllDownload(filters, "INWARD")
        .then((res) => {
          if (res !== "" && res !== undefined) {
            FileDownload(res, "Transaction.xlsx");
            notify.success("Downloaded!");
          } else {
            notify.error("Not able to download file in given filter!");
          }
        })
        .catch(() => {
          notify.error("Error while Downloading!");
        })
        .finally(() => setShowLoader(false));
    }
  };

  const handleBankTableChange = (pagination) => {
    setCurrentPageBank(pagination.current - 1);
  };
  const isPartialValidDate = (value) => {
    if (!/^(\d{0,4})(-(\d{0,2})(-(\d{0,2})?)?)?$/.test(value)) {
      return false;
    }
    const parts = value.split("-");
    if (parts[0] && parts[0].length > 4) {
      return false;
    }
    if (parts[1]) {
      if (parts[1].length > 2) {
        return false;
      }
      const month = parseInt(parts[1], 10);
      if (parts[1].length === 2 && (month < 1 || month > 12)) {
        return false;
      }
    }
    if (parts[2]) {
      if (parts[2].length > 2) {
        return false;
      }
      const day = parseInt(parts[2], 10);
      if (parts[2].length === 2 && (day < 1 || day > 31)) {
        return false;
      }
    }
    return true;
  };

  const handleDateKeyDown = (event) => {
    if (event.metaKey || event.ctrlKey || event.altKey) {
      return;
    }
    const allowedKeys = [
      "Backspace",
      "Tab",
      "Enter",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Delete",
    ];
    const allowedChars = ["-", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    const { key, target } = event;
    if (allowedKeys.includes(key)) {
      return;
    }
    if (allowedChars.includes(key)) {
      const start = target.selectionStart ?? target.value.length;
      const end = target.selectionEnd ?? target.value.length;
      const nextValue =
        target.value.slice(0, start) + key + target.value.slice(end);
      if (
        nextValue.length <= 10 &&
        isPartialValidDate(nextValue) &&
        (key !== "-" || nextValue.split("-").length - 1 <= 2)
      ) {
        return;
      }
    }
    event.preventDefault();
  };

  const stagesFilter = [
    {
      label: "Initiated",
      value: "INITIATED",
    },
    {
      label: "Transaction Initiated",
      value: "TRANSACTION_INITIATED",
    },
    {
      label: "Approved",
      value: "APPROVED",
    },
    {
      label: "Completed",
      value: "COMPLETED",
    },
    {
      label: "Draft",
      value: "DRAFT",
    },
  ];

  useEffect(() => {
    getReceivableTransactions(currentPage);
  }, [currentPage]);

  const tabChangeHandler = () => {};

  const cols = [
    {
      title: "Transaction ID",
      dataIndex: "receivableId",
      key: "receivableId",
      align: "center",
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
      align: "center",
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Payer Name",
      dataIndex: "xflowPartnerNickName",
      key: "xflowPartnerNickName",
      align: "center",
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Creation Date",
      data: "creationTime",
      key: "creationTime",
      align: "center",
      render: (val, record) =>
        record?.creationTime ? DateConvert(Number(record?.creationTime)) : "-",
    },
    {
      title: "Last Updated",
      data: "lastUpdatedTime",
      key: "lastUpdatedTime",
      align: "center",
      render: (val, record) =>
        record?.lastUpdatedTime
          ? DateConvert(Number(record?.lastUpdatedTime))
          : "-",
    },
    {
      title: "Due Date",
      data: "invoiceDueDate",
      key: "invoiceDueDate",
      align: "center",
      render: (_, record) =>
        record?.invoiceDueDate ? record.invoiceDueDate : "-",
    },
    {
      title: "Stage",
      data: "receivableStatus",
      key: "receivableStatus",
      align: "center",
      render: (_, record) =>
        record?.receivableStatus ? record.receivableStatus : "-",
    },
    {
      title: "Amount",
      data: "amount",
      key: "amount",
      align: "center",
    },
  ];

  const colsBanks = [
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
      key: "transactionId",
      align: "center",
      render: (_, record) =>
        record?.transactionId && (
          <Link
            to={"/transactiondetail/inward/" + record?.transactionId}
            style={{
              color: "#000",
            }}
            onClick={() => {
              setTransactionId(record?.transactionId);
            }}
          >
            {record?.transactionId ? record.transactionId : "-"}
          </Link>
        ),
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
      align: "center",
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Payer Name",
      dataIndex: "vendorName",
      key: "vendorName",
      align: "center",
      render: (_, record) => {
        return record?.partner?.nickname ? record?.partner?.nickname : "-";
      },
    },
    {
      title: "Creation Date",
      data: "initiationDate",
      key: "initiationDate",
      align: "center",
      render: (val, record) =>
        DateConvert(record?.initiationDate)
          ? DateConvert(record?.initiationDate)
          : "-",
    },
    {
      title: "Last Updated",
      data: "lastUpdatedDate",
      key: "lastUpdatedDate",
      align: "center",
      render: (val, record) =>
        DateConvert(record?.lastUpdatedDate)
          ? DateConvert(record?.lastUpdatedDate)
          : "-",
    },
    {
      title: "Due Date",
      data: "completionDate",
      key: "completionDate",
      align: "center",
      render: (_, record) =>
        record?.invoice?.[0]?.due_date_of_payment
          ? record?.invoice?.[0]?.due_date_of_payment
          : "-",
    },
    {
      title: "Bank/Partner Name",
      data: "bankName",
      key: "bankName",
      align: "center",
      render: (_, record) => (record?.bankName ? record.bankName : "-"),
    },
    {
      title: "Stage",
      data: "stage",
      key: "stage",
      align: "center",
      render: (_, record) => (record?.stage ? record.stage : "-"),
    },
    {
      title: "Assigned To",
      data: "assignedOpsMember",
      key: "assignedOpsMember",
      align: "center",
      render: (_, record) =>
        record?.assignedOpsMember ? record.assignedOpsMember : "-",
    },
    {
      title: "Amount",
      data: "amount",
      key: "amount",
      align: "center",
      render: (val, record) =>
        `${
          record?.invoice?.[0]?.currency_code
            ? record?.invoice?.[0]?.currency_code
            : "-"
        } ${record?.invoice?.[0]?.amount ? record?.invoice?.[0]?.amount : "-"}`,
    },
  ];

  const items = [
    {
      key: "1",
      label: "Banks",
      children: (
        <Box component={Paper}>
          <Table
            columns={colsBanks}
            dataSource={inwardBankTransactions}
            pagination={{
              pageSize: 10,
              total: totalBanks,
              showSizeChanger: false,
              position: ["bottomCenter"],
              current: currentPageBank + 1,
            }}
            rowKey={(record) => record?.transactionId}
            onChange={handleBankTableChange}
            className="styledAntd"
          />
        </Box>
      ),
    },
    // PG
    // {
    //     key: '2',
    //     label: 'PayGlocal',
    //     children:
    //     <Box component={Paper}>
    //     <Table
    //         columns={cols}
    //         dataSource={inwardTransactions}
    //         style={{}}
    //         pagination={{
    //             pageSize: 10,
    //             total: total,
    //             showSizeChanger: false,
    //             position: ["bottomCenter"],
    //             current: currentPage + 1
    //         }}
    //         rowKey={(record) => record?.transactionId}
    //         // onChange={handleChange}
    //         className="styledAntd"
    //     />
    //     </Box>
    // }
  ];

  return (
    <Box
      className={props.activeTab ? props.activeTab + " tabmain" : "tabmain"}
      sx={{ padding: "1rem", width: "100%" }}
    >
      <div className="alltnx_container">
        <Typography.Title level={2}>Inward Transactions</Typography.Title>

        <div className="alltxn_buttons_container">
          <Tooltip title="Reset all filters and sync with latest data">
            <Button
              icon={<ReplayCircleFilled />}
              type="ghost"
              onClick={() => {
                alltxnForm.resetFields();
                setFilterValues({});
                setCurrentPageBank(0);
                setFilterModeOn(!filterModeOn);
                localStorage.removeItem(FILTER_STORAGE_KEY);
              }}
            >
              RESET
            </Button>
          </Tooltip>
          <Button
            type="primary"
            onClick={showDrawer}
            icon={<FilterAlt />}
          ></Button>
          <Button
            type="primary"
            icon={<Download />}
            onClick={handleFiltersDownload}
          >
            Download
          </Button>
        </div>
      </div>
      <Tabs defaultActiveKey="1" items={items} onChange={tabChangeHandler} />
      <Drawer
        open={openDrawer}
        onClose={onCloseDrawer}
        title={
          <Typography.Title
            level={4}
            style={{
              margin: 0,
              padding: 0,
              textTransform: "uppercase",
            }}
          >
            Table Filters
          </Typography.Title>
        }
        closeIcon
        extra={
          <Space>
            <Button
              icon={<Close />}
              type="ghost"
              onClick={onCloseDrawer}
            ></Button>
          </Space>
        }
      >
        <Form
          layout="vertical"
          onFinish={(values) => {
            const nicknameInput =
              typeof values?.nickname === "string"
                ? values.nickname.trim()
                : undefined;
            if (
              values?.CustomerListSelection === undefined &&
              nicknameInput === undefined &&
              values?.toFrom === undefined &&
              values?.assignedOpsMemberId === undefined &&
              values?.stage === undefined
            ) {
              setFilterValues({});
              onCloseDrawer();
              setFilterModeOn(!filterModeOn);
              return;
            }
            const finalValues = {
              ...values,
              nickname: nicknameInput || undefined,
            };
            localStorage.setItem(
              FILTER_STORAGE_KEY,
              JSON.stringify(finalValues)
            );
            setCurrentPageBank(0);
            setFilterValues(finalValues);
            setFilterModeOn(!filterModeOn);
            onCloseDrawer();
          }}
          form={alltxnForm}
        >
          <Typography.Title
            level={5}
            style={{
              textTransform: "uppercase",
            }}
          >
            Filter by Customer Name
          </Typography.Title>

          <Form.Item
            name={"CustomerListSelection"}
            label="Search and Select Customers"
            tooltip="You can add multiple customers"
          >
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select Customers you want to filter"
              optionLabelProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={orgName?.length ? orgName : []}
            ></Select>
          </Form.Item>
          <Divider />
          <Typography.Title
            level={5}
            style={{
              textTransform: "uppercase",
            }}
          >
            Filter by Payer Nickname
          </Typography.Title>
          <Form.Item
            name={"nickname"}
            label="Enter Payer Nickname"
            tooltip="Filter transactions by payer nickname"
          >
            <Input placeholder="Enter nickname" allowClear />
          </Form.Item>
          <Divider />
          <Typography.Title
            level={5}
            style={{
              textTransform: "uppercase",
            }}
          >
            Filter by Date range
          </Typography.Title>
          <Form.Item label={"Date Range By"} name={"dateRangeByVal"}>
            <Radio.Group
              onChange={(e) => setDateRangeBy(e.target.value)}
              defaultValue={dateRangeBy}
            >
              <Radio value={"isDateRangeOnCompletionTime"}>
                Completion Date
              </Radio>
              <Radio value={"isDateRangeOnLastUpdatedTime"}>
                Last Updated Date
              </Radio>
              <Radio value={"isDateRangeOnCreationTime"}>Initiated Date</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Select Date Range"
            tooltip="Provide from and to date"
            name={"toFrom"}
          >
            <RangePicker
              format="YYYY-MM-DD"
              allowClear
              placeholder={["YYYY-MM-DD", "YYYY-MM-DD"]}
              onKeyDown={handleDateKeyDown}
            />
          </Form.Item>
          <Divider />
          <Typography.Title
            level={5}
            style={{
              textTransform: "uppercase",
            }}
          >
            Filter by Assigned To
          </Typography.Title>

          <Form.Item
            label="Select Assigned Ops Member"
            tooltip="You can choose Ops member"
            name="assignedOpsMemberId"
          >
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select assigned ops you want to filter"
              optionLabelProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={opsMembers?.length ? opsMembers : []}
            ></Select>
          </Form.Item>
          <Divider />
          <Typography.Title
            level={5}
            style={{
              textTransform: "uppercase",
            }}
          >
            Filter by Stage
          </Typography.Title>

          <Form.Item
            label="Select Stage"
            tooltip="You can filter by stage of transaction"
            name="stage"
          >
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select Stages you want to filter"
              optionLabelProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={stagesFilter?.length ? stagesFilter : []}
            ></Select>
          </Form.Item>
          <Space size={"middle"}>
            <Button htmlType="submit" type="primary">
              Submit
            </Button>
            <Button
              onClick={() => {
                alltxnForm.resetFields();
                setFilterValues({});
                setFilterModeOn(!filterModeOn);
                onCloseDrawer();
                setCurrentPageBank(0);
                localStorage.removeItem(FILTER_STORAGE_KEY);
              }}
            >
              Reset All
            </Button>
          </Space>
        </Form>
      </Drawer>
    </Box>
  );
};

export default InwardTransactions;
